export default __webpack_public_path__ + "images/ae6dd4fa8eb7c9ddb11f686075038ec4.jpg";